import { render, staticRenderFns } from "./NotificationInbox.vue?vue&type=template&id=1b7e8f9b&scoped=true"
import script from "./NotificationInbox.vue?vue&type=script&lang=js"
export * from "./NotificationInbox.vue?vue&type=script&lang=js"
import style0 from "./NotificationInbox.vue?vue&type=style&index=0&id=1b7e8f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e8f9b",
  null
  
)

export default component.exports